<template>
    <div>
        <ak-upload
            v-bind="$props"
            v-on="$listeners"
            v-model="imageValue"
        >
            <template v-slot:files="{files, outputFiles, showImagePreview, downloadPath, remove}">
                <draggable
                    tag="div"
                    v-if="currentValue.length"
                    v-model="currentValue"
                    class="cms-media-control__files"
                >
                    <div
                        v-for="object in currentValue"
                        :key="object.id"
                        class="cms-media-control__file"
                    >
                        <cms-media-card
                            v-if="isFileObject(object)"
                            :clickable="false"
                            :body="object.originalFilename"
                            :img="showImagePreview(object) && object.downloadPath ? downloadPath(object) : null"
                            :downloadPath="showImagePreview(object) && object.downloadPath ? downloadPath(object) : null"
                            :recommendedFileSize="recommendedFileSize"
                            :fileSize="object.fileSize"
                            size="small"
                        >
                            <template v-slot:top="{img}">
                                <div  class="cms-media-control__preview">
                                    <div v-if="!showImagePreview(object) && object.description" class="ak-upload__preview-image d-flex align-items-end justify-content-center">
                                        <div   class="ak-upload__preview-name">
                                            {{object.description}}
                                        </div>
                                    </div>
                                    <img v-if="showImagePreview(object) && object.downloadPath " :src="img">

                                    <a class="ak-upload__preview-download"
                                       :href="downloadPath(object)">
                                        <div class="ak-upload__preview-download-label">
                                            <span class="ak-icon">download</span>
                                            Download
                                        </div>
                                    </a>

                                    <a
                                        class="ak-upload__file-remove"
                                        @click="remove(object)"
                                    >
                                        <span class="ak-icon">close</span>
                                    </a>
                                </div>
                            </template>
                        </cms-media-card>
                        <ak-widget
                            v-if="object.widget"
                            :type="object.widget.type"
                            :attributes="{...object.widget.attributes, id: object.widget.id, baseRelationString: id, recommendedFileSize: recommendedFileSize }"
                            :slots="object.widget.slot"
                            :objectId="object.id"
                            contextType="grid-cell"
                            :callbackUri="`/${currentRelation.foreignList.bundle}/${currentRelation.foreignList.id}/`"
                        >
                            <template v-slot:contextual-widgets="{slotListeners}">
                                <ak-popover-menu
                                    direction="right"
                                >
                                    <template v-slot:trigger="{open:open, toggleMenu:toggleMenu}">
                                        <ak-button
                                            class="ak-table__contextual-trigger"
                                            size="x-small"
                                            :active="open"
                                            :disableBackground="true"
                                            colorMode="text-bg"
                                            @click="toggleMenu"
                                        >
                                            <i class="ak-icon ak-icon--large ak-icon--bolt">
                                                more_horiz
                                            </i>
                                        </ak-button>
                                    </template>

<!--                                    <ak-popover-menu-item-->
<!--                                        v-if="slotListeners?.download"-->
<!--                                        :title="$t('Download')"-->
<!--                                        icon="download"-->
<!--                                        @click="slotListeners.download"-->
<!--                                    />-->
<!--                                    <ak-popover-menu-item-->
<!--                                        v-if="slotListeners?.showMediaInspector"-->
<!--                                        :title="$t('Media inspector')"-->
<!--                                        icon="info"-->
<!--                                        @click="slotListeners.showMediaInspector"-->
<!--                                    />-->
                                    <ak-popover-menu-item
                                        :title="$t('Wijzigen')"
                                        icon="edit"
                                        @click="edit(object)"
                                    />
                                </ak-popover-menu>

                                <a
                                    href="#"
                                    class="ak-upload__file-remove ak-upload__file-remove--left"
                                    @click.prevent="deleteSelected(object.id)"
                                >
                                    <span class="ak-icon">close</span>
                                </a>
                            </template>
                        </ak-widget>
                    </div>
                </draggable>
            </template>

            <template v-slot:button>
                <div class="cms-media-control__buttons">
                    <template v-if="enableUpload">
                        <a href="#" class="ak-button ak-button--small ak-button--ghost ak-upload__button cms-media-control__button">
                            {{ $t('Kies van computer') }}
                        </a>
                        {{ $t('of') }}
                    </template>

                    <router-link class="ak-button ak-button--small ak-button--outlined cms-media-control__button" :to="mediaLibraryRoute">
                        {{ $t('Kies uit media bibliotheek') }}
                    </router-link>
                </div>
            </template>
        </ak-upload>

        <cms-media-relation-resolver
            v-if="renderRelationResolver"
            :relationString="currentRelationString"
            :relationReference="`${bundleId},${definitionId}`"
            :defaultIdsSelected="selectedIds"
            :enableForeignList="enableForeignList"
            @close="triggerClose"
            @updateRelations="updateRelations"
            @refresh="updateRelations"
        />
    </div>
</template>

<script>
import FormElementRelationMixin from '../../../../vendor/multimedium/spine/resources/spine-appkit-vue/src/components/form/mixins/FormElementRelationMixin';

export default {
    name: 'custom-media-control',
    mixins: [FormElementRelationMixin],
    props: {
        baseUri: {
            type: String,
            required: false,
            default: ''
        },
        extensions: {
            type: String,
            required: true,
        },
        mimeTypes: {
            type: String,
            required: true,
        },
        size: {
            type: String | Number,
            required: true,
        },
        multiple: {
            type: String | Number,
            required: false,
            default: false
        },
        allowDirectory: {
            type: Boolean,
            required: false,
            default: false
        },
        maximumNumberOfFiles: {
            type: String | Number,
            required: false
        },
        recommendedFileSize: {
            type: String,
        },
        cta: {
            type: String,
            required: false,
            default() {
                return this.multiple ? "Drop uw bestanden hier" : "Drop uw bestand hier";
            }
        },
        enableUpload: {
            type: Boolean,
            required: true,
            default: true
        }
    },
    data() {
        return {
            currentRelation: null,
            enableForeignList: true,
            imageValue: [],
        }
    },
    computed: {
        /**
         * The Media Library route object
         * @returns {{name: string, params: {}}}
         */
        mediaLibraryRoute() {
            let params = {};
            params = Object.assign(params, this.$route.params);

            if (params.relationString != undefined) {
                params.relationString += ':' + this.mediaLibraryRelationString;
            } else {
                params.relationString = this.mediaLibraryRelationString;
            }

            return {
                name: this.$route.name,
                params: params
            }
        },
        /**
         * The string for the relation for the media list
         * @returns {string}
         */
        mediaLibraryRelationString() {
            return `${this.id}:list:${this.currentRelation.foreignList.bundle}:${this.currentRelation.foreignList.id}`;
        },
    },
    watch: {
        currentRelation: {
            deep: true,
            handler() {
                this.setMediaObjects(this.currentRelation.selected);
            }
        },
        imageValue: {
            deep: true,
            handler() {
                this.setMediaObjects(this.imageValue);
            }
        },
    },
    methods: {
        /**
         * Set the new value for media objects
         *
         * @param newValue
         */
        setMediaObjects(newValue) {
            // if we allow multiple values we concat the selected items in the relation width the imageValue
            if (this.multiple) {
                this.currentValue = this.imageValue.concat(this.currentRelation.selected);
                return;
            }
            // else we use the newValue given in the params
            // This can be a selected item in the relation or a imageValue

            this.currentValue = [];
            if(newValue[0]) {
                // we need to use splice otherwise vue doesn't pickup the change
                this.currentValue.splice(0, 1, newValue[0]);
            }
        },
        /**
         * Check if the given object is a file object
         * @param object
         * @returns {boolean}
         */
        isFileObject(object) {
            return object.downloadPath !== undefined;
        },
        /**
         * Trigger Close
         */
        triggerClose() {
            this.$router.back();
        },
        /**
         * Trigger edit form for media object
         * @param object
         */
        edit(object) {
            let params = this.$route.params;

            if(! params.relationString) {
                params.relationString = this.id;
            }
            // add the formDefinition & object Id to the relation ID
            params.relationString = params.relationString + ':form:'+ this.currentRelation.foreignList.bundle + ':form:' + object.id;

            //redirect to the new relation state
            this.$router.push({ name: this.$route.name , params: params});
        }
    }
};
</script>
